var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChurnDataModal',{attrs:{"open":_vm.showChurnData,"loading":_vm.loading},on:{"update:open":function($event){_vm.showChurnData=$event},"getEmails":_vm.sendEmails}})}
var staticRenderFns = []

export { render, staticRenderFns }